import './App.css';
import Game from './pages/game'; // Ensure the filename is "Game.js" or adjust casing
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Game />} />
        <Route path="/game/:id" element={<div>Game Detail Page</div>} />
      </Routes>
    </Router>
  );
}

export default App;
